<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img :src="logo"></td>
        <td width="40%" align="center" style="vertical-align: top"><div class="info-text">Оплата {{ nameProv }}</div></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Введите сумму к зачислению от {{minSum}} до {{maxSum}} руб.</div>
        </td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="fon-input">
            <input type="text" readonly class="input-field" v-model="sumPretty">
            <img @click="clickBsKey" class="bnt-key-bs" src="/imgs/btn_bs_1.png">
          </div>
        </td>
      </tr>
      <tr>
        <td class="td-row" width="30%">
          <div class="info-text-right">
            Комиссия за перевод с кошелька<br>{{ this.prov !== null ? (this.prov.comission + this.prov.comissiontp) : ''}}%
          </div>
          <div class="info-text-right">
            Сумма к оплате<br>{{ moneyFormat(paySum) }} руб.
          </div>
          <div class="info-text-right">
            Баланс кошелька<br>{{ this.user !== null ? moneyFormat(this.user.balance / 100.0) : ''}} руб.
          </div>
        </td>
        <td class="td-row" width="40%" align="center">
          <KeyboardDigital :on-click="onClickKey" :is-sum="true"></KeyboardDigital>
        </td>
        <td width="30%">
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" src="/imgs/back_1.png">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="mainClick" src="/imgs/menu_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="fwdClick" src="/imgs/fwd_1.png" v-show="checkedValue">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
  </div>
</template>

<style>

</style>
<script>
import KeyboardDigital from "@/components/KeyboardDigital.vue";
import LoaderWait from "@/components/LoaderWait.vue";
import MessageBox from "@/components/MessageBox.vue";
import { moneyFormat } from "@/utils/money_format.js";
import { calcComis } from "@/utils/calc_comis";

export default {
  name: 'InputSumPage',
  components: { MessageBox, LoaderWait, KeyboardDigital },
  data () {
    return {
      loading: false,
      timer: null,
      sum: '',
      showMessage: false,
      errorMessage: '',
    }
  },
  computed: {
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    prov() {
      const data = this.$store.getters.PROV_INFO
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    logo() {
      if (this.prov !== null) {
        return '/imgs/op/' + this.prov.img;
      }
      return '/imgs/logo_impay.png'
    },
    minSum() {
      if (this.prov !== null) {
        return this.prov.minSum;
      }
      return 0;
    },
    maxSum() {
      if (this.prov !== null) {
        return this.prov.maxSum;
      }
      return 0;
    },
    checkedValue() {
      const sum = parseFloat(this.sum);
      return !isNaN(sum) && sum <= this.maxSum && sum >= this.minSum
    },
    sumPretty() {
      const sum = parseFloat(this.sum);
      if (!isNaN(sum)) {
        return this.sum.replace('.', ',')
      }
      return ''
    },
    paySum() {
      const sum = parseFloat(this.sum);
      console.log(this.sum)
      if (!isNaN(sum) && this.prov !== null) {
        return sum + calcComis(sum, this.prov.comission, this.prov.comissiontp);
      }
      return 0;
    },
    nameProv() {
      if (this.prov !== null) {
        return this.prov.name
      }
      return 'услуги'
    }
  },
  mounted() {
    this.updateTimer()
  },
  methods: {
    moneyFormat,
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.timerExit(), 120000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerExit() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    onClickKey(key) {
      this.updateTimer()
      if (key === '.') {
        if (this.sum.length > 0 && this.sum.indexOf('.') === -1) {
          this.sum = this.sum + key
        }
      } else {
        if (parseFloat(this.sum + key) < this.maxSum &&
            (this.sum.indexOf('.') === -1 || (this.sum.indexOf('.') >= 0 && this.sum.length - this.sum.indexOf('.') < 3))
        ) {
          this.sum = this.sum + key
        }
      }
    },
    clickBsKey() {
      this.updateTimer()
      this.sum = ''
    },
    fwdClick() {

      if (!this.sum.length) {
        return false;
      }

      const amount = parseFloat(this.sum);
      if (parseFloat(this.paySum.toFixed(2)) <= parseFloat((this.user.balance / 100.0).toFixed(2))) {
        this.stopTimer()
        this.loading = true
        this.$store.dispatch('SAVE_AMOUNT_PROV', {
          amount: amount
        }).then(() => {
          this.loading = false
          this.$router.push('input-confirm')
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.updateTimer()
        this.messageShow('Недостаточно средств');
      }
    },
    backClick() {
      this.stopTimer()
      this.$router.go(-1)
    },
    mainClick() {
      this.stopTimer()
      this.$router.go(-2)
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    },
  }
}
</script>
